import { Input, message } from "antd";
import { useTranslation } from "react-i18next";

interface TextAreaProps {
  maxLength: number;
  autoComplete?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
}

const TextArea: React.FC<TextAreaProps> = ({ maxLength, ...rest }) => {
  const { TextArea } = Input;
  const [t] = useTranslation("common");
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // Updated event handler type
    const { value } = e.target;

    if (value.length <= maxLength) {
      rest.onChange?.(value);
    } else {
      message.warning("Maximum length reached!");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // Updated event handler type
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <TextArea
      {...rest}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={`${t("enter-text")}`}
      className="scrollable-textarea"
      autoComplete="off"
      autoSize={{ minRows: 4, maxRows: 4 }}
    />
  );
};

export default TextArea;
